import { render } from "./DepartmentUploadFiles.vue?vue&type=template&id=186de7ed&scoped=true"
import script from "./DepartmentUploadFiles.vue?vue&type=script&lang=js"
export * from "./DepartmentUploadFiles.vue?vue&type=script&lang=js"

import "./DepartmentUploadFiles.vue?vue&type=style&index=0&id=186de7ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186de7ed"]])

export default __exports__